import is from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'

const GoBackButton = styled.a<IGoBackButton>`
  margin-top: ${({ size }) => (size ? 10 * size : 10)}px;
  margin-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  margin-left: ${({ size }) => (size ? 10 * size : 10)}px;
  border-radius: 3px;
  background-color: #e88484;
  color: white;
  cursor: pointer;
  border: 1px solid white;
  padding: ${({ size }) => (size ? 7 * size : 7)}px
    ${({ size }) => (size ? 10 * size : 10)}px;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  overflow: hidden;
  line-height: ${({ size }) => (size ? 22 * size : 22)}px;

  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    text-overflow: ellipsis;
  }

  ${is('expanded')`
  position: absolute;
    z-index: 3;
    max-height: ${({ size }) => (size ? 36 * size : 36)}px;
    max-width: 94%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`

export default GoBackButton

export interface IGoBackButton {
  expanded?: boolean
  size?: number
}
